<template>
    <main class="SectionParenthesis-MAIN DISPLAY">

        <HeaderBand/>

        <section class="SectionParenthesis-articles hide-scrollbar">
            <div class="example" v-for="index in 10" :key="index">
                <h1>DEFINICIÓN DE SISTEMA</h1>
                <hr/>
                <span>REF: 000/BASE</span>
                <p>
                    Estructura de soporte técnico para el desarrollo de proyectos.
                    El restultado no es el centro; el interés reside en la cadena de decisiones y la trazabilidad operativa.
                    No hay acumulación de carrera, solo evidencia de proceso.
                </p>
                <button>LEER MÁS</button>
            </div>
        </section>   

    </main>
</template>

<script>
import HeaderBand from '@/components/HeaderBand.vue';

export default {
    name: 'SectionParenthesis',
    components: {
        HeaderBand,
    },
    data(){
        return{
            filterBtn: 'lasts'
        }
    }
}
</script>

<style scoped lang="stylus">
.SectionParenthesis-MAIN
    max-height: 100dvh !important
    overflow: hidden
    min-height: 0

.SectionParenthesis-articles
    flex: 1 1 auto
    min-height: 0
    overflow-y: auto
    margin-top: -3vw
    padding-top: 5vw
    mask-image: linear-gradient(to bottom, transparent 0%, white 5%, white 90%, transparent 100%)
    -webkit-mask-image: linear-gradient(to bottom, transparent 0%, white 5%, white 90%, transparent 100%)

/* example */
.example
    background-color: white
    color: black
    padding: 4vw
    margin: 4vw
    margin-top: 4vw
    border-radius: 5vw
    position: relative
    padding-bottom: calc(4vw + 47px)

    h1
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 500
        font-size: 7vw
        margin: 0

    hr
        width: 100%
        border: 1px solid #DCDCDC

    span
        font-family: "DM Mono", monospace
        font-size: 5vw
        color: #DCDCDC

    p
        font-family: "Archivo ExtraCondensed", sans-serif
        font-size: 5vw
        margin-bottom: 12vw

    button
        font-family: "DM Mono", monospace
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: rgb(1, 90, 255)
        border: none
        color: white
        max-width: 75vw
        border-radius: 100vw
        position: absolute
        margin: 0 auto
        left: 0
        right: 0
        bottom: 4vw
    
</style>